import { Card, CardContent, CardHeader, CardTitle } from "@/components/ui/card"
import { Tabs, TabsContent, TabsList, TabsTrigger } from "@/components/ui/tabs"

import { OrdersCreateOrdersForm } from "./form"
export const OrdersCreateOrdersTabs = () => {
  return (
    <Tabs defaultValue="details">
      <TabsList>
        <TabsTrigger value="details">Detalhes</TabsTrigger>
      </TabsList>
      <TabsContent value="details">
        <Card>
          <CardHeader>
            <CardTitle>Detalhes do pedido</CardTitle>
          </CardHeader>
          <CardContent>
            <OrdersCreateOrdersForm />
          </CardContent>
        </Card>
      </TabsContent>
      <TabsContent value="products">Produtos</TabsContent>
    </Tabs>
  )
}
